// extracted by mini-css-extract-plugin
module.exports = {"valueWrapper":"styles_valueWrapper__2pjrx","value":"styles_value__2HQSt","isPlaceholder":"styles_isPlaceholder__2a-ci","icon":"styles_icon__hD4km"};